$(function() {
    "use strict";

    var $cropModal = $();
    var $cropWindow = $();
    var $cropPreview = $();
    var $cropPreviewWrapper = $();
    var cropImageWidth = 0;
    var cropImageHeight = 0;
    var $cropUploadedImg = null;
    var $cropLoader;
    var $cropError;
    var $cropTitle;
    var $cropImageBlock;
    var $cropModalImage;
    var $cropSaveButton;
    var cropLoadingHandler = {};
    var cropModalId = 'modal_image-crop';
    var $link = $();
    var jcropApi;


    $(document).on('ready', function () {
        $cropModal = $('#modal_image-crop');
        $cropWindow = $cropModal.find('.modall__window');
        $cropImageBlock = $cropModal.find('.modal_image-crop__image');
        $cropModalImage = $cropModal.find('.modal_image-crop__image__image');
        $cropPreview = $cropModal.find('.modal_image-crop__image-preview__src');
        $cropPreviewWrapper = $cropPreview.closest('.modal_image-crop__image-preview');
        $cropLoader = $cropModal.find('.modal_image-crop__loader');
        $cropError = $cropModal.find('.modal_image-crop__error');
        $cropTitle = $cropModal.find('.modal_image-crop__title');
        $cropSaveButton = $cropModal.find('.modal_image-crop__image-submit');

        $cropSaveButton.on('click', function(e) {
            e.preventDefault();

            $cropLoader.addClass('modal_image-crop__loader-active');

            var selection = jcropApi.tellSelect();

            $.ajax({
                   data: {
                       src_image_url: $cropUploadedImg.attr('src'),
                       crop: {
                           width: selection.w,
                           height: selection.h,
                           x: selection.x,
                           y: selection.y
                       }
                   },
                   cache: false,
                   url: $cropModal.data('ajaxUrl'),
                   type: 'POST',
                   success: function(data) {
                       insertLoadingToACard($link);

                       setLoadingHandler($link, data.photo_id);
                       if ($link.data('firmCardBlock')) {
                           $.ajax({
                               url:      '/save-promoted-media/', // TODO: Send ajax to proper url
                               type:     'POST',
                               dataType: 'json',
                               data:     {
                                   block_code:  $link.data('firmCardBlock'),
                                   object_type: $link.data('firmCardObjectType'),
                                   object_id:   data.photo_id,
                                   position:    $link.data('firmCardPosition')
                               }
                           });
                       } else if ($link.data('topicCover')) {
                           var $photoInput = $link.closest('form').find('[name*="\[photo_id\]"]');
                           if ($photoInput.length > 0) {
                               $photoInput.val(data.photo_id);
                           }
                       }
                       Modal.closeModal(cropModalId);
                   },
                   error: function(xhr) {
                       var message = '';
                       if (typeof(xhr.responseJSON) != 'undefined' && typeof(xhr.responseJSON.error) != 'undefined') {
                           message = xhr.responseJSON.error;
                       } else {
                           message = 'Произошла ошибка сохранения изображения. Попробуйте повторить попытку.';
                       }

                       showCropError(message);
                   },
                   complete: function() {
                       $cropLoader.removeClass('modal_image-crop__loader-active');
                   }
               });
        });

        $(document).on('Modal::close', function(event, modal) {
            if (modal.prop('id') != cropModalId) {
                return;
            }

            if (jcropApi) {
                jcropApi.destroy();
            }
            $cropModal.data('photoId', null);
            $cropModal.data('imageSrc', null);
            $cropUploadedImg = null;
            $cropImageBlock.addClass('modal_image-crop__image-hidden');
            $cropError.hide();
            $cropPreviewWrapper.hide();
            $cropSaveButton.hide();
            $cropLoader.removeClass('modal_image-crop__loader-active');
            $cropModalImage.empty();
        });


        $(document).trigger('PhotoUploadOverlay::registerCallback', [
            {
                name: 'insert-after-crop',
                callbackFunction: function ($target, photos, ideabook, size, isLast) {

                    if (isLast) {
                        $(document).trigger('PhotoUploadOverlay::hide');
                    }

                    $link = $target;
                    showCardCropper(photos[0].id, photos[0].src);
                }
            }
        ]);
    });

    var showCropError = function(message, changeTitle) {
        if (changeTitle) {
            $cropTitle.html('К сожалению, произошла ошибка');
        }
        $cropLoader.removeClass('modal_image-crop__loader-active');
        $cropSaveButton.hide();
        $cropPreviewWrapper.hide();
        $cropError.html(message).show();
    };

    var setLoadingHandler = function(link, photoId) {
        var key = Math.random();
        cropLoadingHandler[key] = function(key, link, photoId) {
            return setInterval(function(){
                var size_name = '';
                if (link.data('firmCardBlock')) {
                    size_name = link.data('firmCardBlock');
                } else if (link.data('topicCover')) {
                    size_name = 'topic_cover';
                }
                $.ajax({
                       cache: false,
                       url: $cropModal.data('checkUrl'),
                       type: 'GET',
                       data: { photo_id: photoId, size_name: size_name },
                       success: function(data) {
                           if (typeof(data.url) != 'undefined') {
                               insertToACard(link, data.url);
                               clearInterval(cropLoadingHandler[key]);
                               cropLoadingHandler[key] = null;
                           }
                       }
                   });
            }, 10000);
        }(key, link, photoId);

    };

    var cropShowPreview = function(coords) {
        var rx = $cropPreviewWrapper.width() / coords.w;
        var ry = $cropPreviewWrapper.height() / coords.h;
        $cropPreview.css({
                         width: Math.round(rx * cropImageWidth) + 'px',
                         height: Math.round(ry * cropImageHeight) + 'px',
                         marginLeft: '-' + Math.round(rx * coords.x) + 'px',
                         marginTop: '-' + Math.round(ry * coords.y) + 'px'
                     }).show();
    };

    var cropRelease = function() {
        jcropApi.setSelect([0, 0, 100, 100]);
    };

    var showCardCropper = function(id, imageSrc) {
        var cropTitle = '';
        var blockName = '';
        if (typeof $link.data('firmCardBlock') !== 'undefined') {
            blockName = $link.data('firmCardBlock');
        } else if (typeof $link.data('topicCover') !== 'undefined' && $link.data('topicCover')) {
            blockName = 'topic_cover';
        }

        switch (blockName) {
            case 'profile_header':
                cropTitle = 'Фотография для шапки';
                break;
            case 'topic_cover':
                cropTitle = 'Фотография для обложки';
                break;
            default:
                cropTitle = 'Фотография для каталога';
                break;
        }
        $cropTitle.html(cropTitle);
        window.Modal.openModal(cropModalId);
        $cropModal.data('photoId', id);
        $cropModal.data('imageSrc', imageSrc);
        $cropLoader.addClass('modal_image-crop__loader-active');
        $cropWindow.css({'max-width': ''});

        $cropError.hide();
        $cropImageBlock.removeClass('modal_image-crop__image-hidden');

        $cropUploadedImg = $('<img src="' + imageSrc + '" style="position: absolute; max-width: none; max-height: none; width: auto; height: auto;" />');
        $cropModalImage.append($cropUploadedImg);

        $cropPreview.attr('src', $cropUploadedImg.attr('src'));

        $cropUploadedImg.on('load', function() {
            $cropPreviewWrapper.show();
            $cropSaveButton.show();
            cropImageWidth = $cropUploadedImg.width();
            cropImageHeight = $cropUploadedImg.height();

            var minWidth = $link.data('firmCardMinWidth') ? $link.data('firmCardMinWidth') : 200;
            var minHeight = $link.data('firmCardMinHeight') ? $link.data('firmCardMinHeight') : 200;

            if (cropImageWidth < minWidth || cropImageHeight < minHeight) {
                $cropUploadedImg.remove();
                $cropImageBlock.addClass('modal_image-crop__image-hidden');
                showCropError('Выбрано слишком маленькое изображение.' + (minWidth ? ' Минимальная ширина - ' + minWidth + '.' : '') + (minHeight ? ' Минимальная высота - ' + minHeight + '.' : ''));
                return;
            }

            var aspectRatio = $link.data('firmCardBlock') == 'profile_header' ? 2.1 : 1;

            var selectWidth = parseInt(cropImageWidth / 1.5);
            var selectHeight = parseInt(cropImageHeight / 1.5);

            selectWidth = parseInt(Math.min(selectWidth, selectHeight * aspectRatio));
            selectWidth = parseInt(Math.max(selectWidth, minWidth));
            selectHeight = parseInt(selectWidth / aspectRatio);

            var selectLeft = parseInt(Math.max(0, (cropImageWidth - selectWidth) / 2));
            var selectTop = parseInt(Math.max(0, (cropImageHeight - selectHeight) / 2));

            $cropPreviewWrapper.css(
                {
                    width: 158 * aspectRatio + 'px',
                    height: 158 + 'px'
                }
            );

            $cropUploadedImg.Jcrop(
                {
                    aspectRatio: aspectRatio,
                    bgColor:     'black',
                    bgOpacity:   .4,
                    minSize: [minWidth, minHeight],
                    setSelect: [selectLeft, selectTop, selectLeft + selectWidth, selectTop + selectHeight],
                    boxHeight: 300,
                    boxWidth: 430,
                    onChange: cropShowPreview,
                    onSelect: cropShowPreview,
                    onRelease: cropRelease,
                    keySupport: false
                },
                function () {
                    jcropApi = this;
                    var imageHolderWidth = $cropModalImage.width();
                    var imagePreviewHolderWidth = $cropPreviewWrapper.width();
                    var newWindowWidth = parseInt($cropWindow.css('max-width')) - (430 - imageHolderWidth) - (210 - imagePreviewHolderWidth);
                    $cropWindow.css({'max-width': newWindowWidth + 'px'});
                    $cropLoader.removeClass('modal_image-crop__loader-active');
                }
            );

        });
    };

    var insertLoadingToACard = function($link) {
        if ($link.hasClass('firm-card__photos__photo') || $link.hasClass('new-post__cover')) {
            $link.find('.media__loading').addClass('media__loading_active');
            if ( $link.hasClass('media_no-media') ) $link.removeClass('media_no-media');
        } else if ($link.closest('.firm-card__medias__media').length > 0) {
            var $linkMedia = $link.closest('.firm-card__medias__media');
            $linkMedia.find('.media__loading').addClass('media__loading_active');

            if ($linkMedia.hasClass('firm-card__medias__media_no-media')) $linkMedia.removeClass('firm-card__medias__media_no-media');
            if ($linkMedia.hasClass('media_no-media')) $linkMedia.removeClass('media_no-media');
        }
    };

    var insertToACard = function($link, imageSrc) {
        if ($link.hasClass('firm-card__photos__photo') || $link.hasClass('new-post__cover')) {
            $link.find('.media__loading').removeClass('media__loading_active');
            $link.find('img').attr('src', imageSrc).attr('width', $link.outerWidth(true)).attr('height', $link.outerHeight(true));
            if ( $link.hasClass('media_no-media') ) $link.removeClass('media_no-media');
        } else if ($link.closest('.firm-card__medias__media').length > 0) {
            var $linkMedia = $link.closest('.firm-card__medias__media');

            $linkMedia.find('.media__loading').removeClass('media__loading_active');

            if ($linkMedia.find('img').length) {
                $linkMedia.find('img').attr('src', imageSrc).attr('width', $linkMedia.outerWidth(true)).attr('height', $linkMedia.outerHeight(true));
            } else {
                $linkMedia.css('background-image', 'url(' + imageSrc + ')');
            }

            if ($linkMedia.hasClass('firm-card__medias__media_no-media')) $linkMedia.removeClass('firm-card__medias__media_no-media');
            if ($linkMedia.hasClass('media_no-media')) $linkMedia.removeClass('media_no-media');
        }
    };
});